import { RuleModel } from "@syncfusion/ej2-react-querybuilder";
import { IAuditEntity } from "@ucl/library";
import { SLAUnits } from "./BoltTaskTemplate";
import { BoltTaskStatuses } from "./BoltTask";

export enum BoltTaskRuleTypes {
  Time = 1,
  Event = 2,
}

export enum TimeRecurrences {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
}

export interface TimeCondition {
  rule: string;
  startDate: string;
}

export interface EventCondition {
  reportName: string;
  rule: RuleModel;
}

export interface IBoltTaskSOP {
  sop?: string;
  sop_AsList?: string[];
}

export interface IBoltTaskSLA {
  sla?: number;
  slaUnit?: SLAUnits;
}

export interface INewBoltTaskRule {
  boltTaskRuleName: string;
  taskTemplateId: string;
  taskTemplateEntityType?: string;
  taskTemplateName?: string;
  taskTemplateDescription?: string;
  taskTemplateSOP?: string;
  taskTemplateSOP_AsList?: string[];
  sOP_AsObject: IBoltTaskSOP;
  taskTemplateSLA?: number;
  taskTemplateSLAUnit?: SLAUnits;
  sLA_AsObject: IBoltTaskSLA;
  taskRuleType: BoltTaskRuleTypes;
  taskRuleType_AsString: string;
  isActive: boolean;
  isUnique: boolean;
  canHaveDuplicateStatuses: BoltTaskStatuses[];
  _canHaveDuplicateStatuses_AsString?: string;
  customerName?: string;
  accountNumber?: string;
  assigneeId?: string;
  taskRuleCondition?: TimeCondition | EventCondition;
  eventCondition?: EventCondition;
  timeCondition?: TimeCondition;
}

export interface IBoltTaskRule extends INewBoltTaskRule, IAuditEntity {}
